// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0e20fe47","455":"ab9a41a3","977":"78246942"}[chunkId] + ".chunk.js";
};